const config = {
  apiAdress: process.env.REACT_APP_API_ADRESS,
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL,
  formStateVersion: 3,
  title: process.env.REACT_APP_TITLE,
  header: process.env.REACT_APP_HEADER,
  agency: process.env.REACT_APP_AGENCY,
  producer: process.env.REACT_APP_PRODUCER,
};

export default config;
